const Auth = {
    isAuthenticated: false,
    authenticate() {
        if (sessionStorage.getItem("bnkauthkey")) {
            this.isAuthenticated = true;
        }
    },
    signout() {
        this.isAuthenticated = false;
        sessionStorage.removeItem("bnkauthkey");
    },
    getAuth() {
        return this.isAuthenticated;
    },
    checkAuth() {        
        this.authenticate();
        return this.isAuthenticated;
    }
};

export default Auth;